export const handleLivescoringSocketResponse = (
    socketResponse,
    competitionId,
    roundId,
    isProduction,
    calculation,
    onUpdateCalculation,
    updateLivescoringData,
    relatedRoundIds = [roundId]
) => {
    const isResultType = "resultado" === socketResponse.tipo
    const isRelatedCompetition = socketResponse.competicion === parseInt(competitionId)

    if (isResultType && isRelatedCompetition) {
        if (socketResponse?.hasToReloadPage != null && socketResponse.hasToReloadPage) {
            location.reload()
        }

        const isRelatedRound = relatedRoundIds.map(Number).includes(parseInt(socketResponse.jornada))
        const isSameEnvironment = isProduction === socketResponse.isProduction
        const livescoringDataReceived = socketResponse.livescoringData
        const livescoringCalculation = socketResponse.calculation

        if (isSameEnvironment && isRelatedRound) {
            updateLivescoringData(livescoringDataReceived, socketResponse.jornada)
        }
    }
}
